if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');



                
                      const desc = document.querySelector('.description-block .metafield-rich_text_field');
                      if (!desc) return;

                      const fullText = desc.innerHTML.trim();
                      const maxLength = 300;

                      if (fullText.length <= maxLength) return;

                      const shortText = fullText.substring(0, maxLength);
                      let expanded = false;

                      desc.innerHTML = `${shortText}<span id="dots">... </span><a id="toggleBtn" style="color:#8F6D4F; font-weight:400; cursor:pointer;">Read more</a>`;

                      desc.addEventListener('click', function (event) {
                        if (event.target && event.target.id === 'toggleBtn') {
                          expanded = !expanded;
                          if (expanded) {
                            desc.innerHTML = `${fullText} <a id="toggleBtn" style="color:#8F6D4F; font-weight:400; cursor:pointer;">Read less</a>`;
                          } else {
                            desc.innerHTML = `${shortText}<span id="dots">... </span><a id="toggleBtn" style="color:#8F6D4F; font-weight:400; cursor:pointer;">Read more</a>`;
                          }
                        }
                      });
                   







            let childSellingPlans = Array.from(document.querySelectorAll('.shopify_subscriptions_fieldset'));

            if (!!childSellingPlans.length) {
              childSellingPlans.forEach(childSellingPlan => {
                if (childSellingPlan) {
                  let sellingRadio = childSellingPlan?.querySelectorAll('input[type=radio]');
                  if (!!sellingRadio.length) {
                    sellingRadio?.forEach(input => {
                      const price = input.getAttribute('data-variant-price');

                      if (!input.nextElementSibling || !input.nextElementSibling.classList.contains('variant-price')) {
                        let sellingPlanId = input.getAttribute('data-selling-plan-id') || '';
                        if(!sellingPlanId) return;
                        const span = document.createElement('span');
                        span.className = 'variant-price';
                        span.textContent = ` ${price}`;
                        input.insertAdjacentElement('afterend', span);
                      }

                      input.addEventListener('input', function () {
                        let sellingPlanId = input.getAttribute('data-selling-plan-id') || '';
                        let quickAddModalForm = input.closest('quick-add-modal')?.querySelector('product-form form');
                        // console.log(input);
                        // console.log(sellingPlanId);
                        // console.log(quickAddModalForm);
                        let sellingPlanInput = quickAddModalForm?.querySelector('input[name="selling_plan"]')

                        if (sellingPlanInput) {
                          sellingPlanInput.value = `${sellingPlanId}`;
                        } else {
                          const planInput = document.createElement('input');
                          planInput.type = 'hidden';

                          planInput.name = 'selling_plan';

                          planInput.value = `${sellingPlanId}`;
                          quickAddModalForm.appendChild(planInput);
                        }
                      })
                    });
                  }
                }
              })
            }
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
